import { Combobox } from '@src/components'
import { REGISTER_COLUMNS } from '@src/constants'
import { RegisterColumn } from './RegisterColumn'

export class DnDocList extends RegisterColumn {
  static type = REGISTER_COLUMNS.DN_DOC_LIST

  constructor (store, settings) {
    const column = {
      header: {
        title: 'Взят на ДН',
        component: Combobox,
        props: {
          allowClear: true,
          options: [
            {
              label: 'Есть',
              value: true,
            },
            {
              label: 'Нет',
              value: false,
            },
          ],
        },
      },
      width: 200,
      dataIndex: 'is_dn',
      dataRender: is_dn => typeof is_dn === 'boolean' ? is_dn ? 'Есть' : 'Нет' : '-',
      sort: true,
    }

    super(column, settings)
  }

  _requestArgs ({ filters }) {

    return {
      control: {
        filters: typeof filters.is_dn === 'boolean'
          ? [{
            field: 'is_dn',
            value: String(filters.is_dn),
            operator: '=',
            invalid: false,
            fieldtype: 'TS',
          }]
          : [],
      },
    }
  }
}
